var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.952 5c0-.394.32-.714.715-.714H17.5a.714.714 0 110 1.429H6.667A.714.714 0 015.952 5zM5.952 10c0-.394.32-.714.715-.714H17.5a.714.714 0 110 1.429H6.667A.714.714 0 015.952 10zM5.952 15c0-.394.32-.714.715-.714H17.5a.714.714 0 110 1.429H6.667A.714.714 0 015.952 15zM1.786 15c0-.394.32-.714.714-.714h.008a.714.714 0 010 1.429H2.5A.714.714 0 011.786 15zM4.423 3.085a.357.357 0 01-.008.505L2.696 5.257a.357.357 0 01-.497 0l-.781-.758a.357.357 0 11.497-.513l.533.517 1.47-1.426a.357.357 0 01.505.008zM4.423 8.085a.357.357 0 01-.008.505l-1.719 1.667a.357.357 0 01-.497 0l-.781-.758a.357.357 0 11.497-.513l.533.517 1.47-1.426a.357.357 0 01.505.008z",
    fill: "#fff"
  })));
}

export default SvgActionPlan;